import axios from "axios";
import { TForm } from "../types";

import { protestingSteps } from "./protestingSteps";
import { legalAdviceSteps } from "./legalAdviceSteps";
import { eligibleSteps } from "./eligibleSteps";
import { guidedSteps } from "./guidedSteps";
import { courtSteps } from "./courtSteps";
import { ineligibleSteps } from "./ineligibleSteps";

const params = new URLSearchParams(window.location.search);
const isProduction = process.env.REACT_APP_ENVIRONMENT === "production";

const FORM_API_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5000/gateway-form"
    : isProduction 
      ? "https://7myn0xdxsa.execute-api.ap-southeast-2.amazonaws.com/gateway-form"
      : "https://s7yux94yd4.execute-api.ap-southeast-2.amazonaws.com/gateway-form";

const formConfig: TForm = {
  start: params.get("start") === "guided" ? "guided-step-one" : "legal-step-one",
  onSubmit: async (values) => {
    const data = {
      ...values,
    };

    // Extract street and suburb from Google Places API object for contact address
    try {
      const { main_text: contactAddress, secondary_text: contactSuburb, postal_code: contactPostcode } =
        values.contactAddress?.value?.structured_formatting;

      data.contactAddress = contactAddress;
      data.contactPostcode = contactPostcode;
      data.contactSuburb = contactSuburb;
    } catch (e) {
      // No address selected
    }

    // Extract street and suburb from Google Places API object for other party address
    try {
      const otherPartyAddress = values.otherPartyAddress?.value?.description;
      data.otherPartyAddress = otherPartyAddress;
    } catch (e) {
      // No address selected
    }
    return axios.post(FORM_API_URL, data);
  },
  steps: {
    ...legalAdviceSteps,
    ...protestingSteps,
    ...eligibleSteps,
    ...guidedSteps,
    ...courtSteps,
    ...ineligibleSteps,
  },
};

export default formConfig;
